export const initialState = {
  networkError: {
    message: '',
  },
};

